export class Formative {
  id: number;
  description: string;
  name: string;
}
